import React from "react";
import { Link } from "react-router-dom";
import { Award, ArrowUpRight } from "lucide-react";

export default function FeaturedProject() {
  return (
    <aside
      data-testid="featured-project"
      className="dark-card"
      style={{
        padding: 24,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Project image area */}
      <Link
        to="/referenciak"
        style={{ display: "block", position: "relative", textDecoration: "none" }}
        data-testid="featured-link"
      >
        <div
          style={{
            aspectRatio: "4 / 3",
            minHeight: 180,
            marginBottom: 18,
            position: "relative",
            backgroundImage: `url("/projects/proj-1.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            border: "1px solid var(--line)",
            overflow: "hidden",
          }}
        >
          <div style={{
            position: "absolute", inset: 0,
            background: "linear-gradient(to top, rgba(11,10,9,0.65) 0%, rgba(11,10,9,0) 60%)",
            pointerEvents: "none",
          }} />
          <div style={{
            position: "absolute", top: 14, left: 14, zIndex: 2,
            background: "var(--ink)", border: "1px solid var(--gold)",
            padding: "5px 10px",
            display: "inline-flex", alignItems: "center", gap: 8,
          }}>
            <Award size={12} color="var(--gold)" strokeWidth={2} />
            <span className="eyebrow" style={{ fontSize: 10 }}>
              Kiemelt munka
            </span>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
          <div>
            <h3 className="h3" style={{ margin: 0, fontSize: 17 }}>
              Modern családi ház
            </h3>
            <p className="small" style={{ margin: "6px 0 0" }}>
              Korcolt lemezfedés
            </p>
          </div>
          <span
            data-testid="featured-arrow"
            style={{
              width: 32, height: 32, flexShrink: 0,
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              border: "1px solid var(--line)", color: "var(--text-dim)",
              transition: "border-color 200ms ease, color 200ms ease",
            }}
          >
            <ArrowUpRight size={14} />
          </span>
        </div>
      </Link>

      {/* Mini-stats footer */}
      <div style={{
        marginTop: 20, paddingTop: 18,
        borderTop: "1px solid var(--line)",
        display: "grid", gridTemplateColumns: "1fr 1fr 1fr",
      }}>
        {[
          { num: "Saját", lbl: "brigád" },
          { num: "Írásos", lbl: "garancia" },
          { num: "Ingyenes", lbl: "felmérés" },
        ].map((s) => (
          <div key={s.lbl} style={{ borderRight: "1px solid var(--line)", padding: "0 14px" }}>
            <div className="font-display" style={{
              fontSize: 15, color: "var(--gold)", lineHeight: 1.1, fontWeight: 500,
            }}>
              {s.num}
            </div>
            <div className="small" style={{ marginTop: 4 }}>
              {s.lbl}
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}
